import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-asset',
  templateUrl: './create-asset.component.html',
  styleUrl: './create-asset.component.scss'
})
export class CreateAssetComponent implements OnInit {

  assetForm!: FormGroup;
  panelList = [ { id: 'Samms', displayName: 'Samms' }];
  clubList:any 

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CreateAssetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.clubList = data.clubList;
  }

  ngOnInit(): void {
    this.assetForm = this.fb.group({
      panelName: ['', Validators.required],
      clubId: ['', Validators.required],
      profile: ['', Validators.required]
    });
  }
  
  submitData(){
    if (this.assetForm.invalid) {
      this.assetForm.markAllAsTouched(); 
      return;
    }
    this.dialogRef.close(this.assetForm.value);
  }
}